module.exports = __webpack_public_path__ + "img/04_green_talk.d6c26375.gif";